<!-- @veltra/icons generated sha256:b2f9d09cb1c25199 gen:8 source:src/svg/normal/folder.svg -->
<script setup lang="ts">
defineOptions({ name: 'Folder' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      fill="currentColor"
      d="M1.5 3.5a1 1 0 0 1 1-1h3.091l.13.095L7.663 4H13.5a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1h-11a1 1 0 0 1-1-1zm3.767 0h-2.27a.495.495 0 0 0-.497.498v8.504a.49.49 0 0 0 .49.498h10.02a.5.5 0 0 0 .49-.51V5.51a.5.5 0 0 0-.493-.51H7.338l-.131-.095z"
    />
  </svg>
</template>
